import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@icon/milestoneIcon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-a1460b18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label-pic is-green" }
const _hoisted_2 = { class: "notification-title-flex" }
const _hoisted_3 = { className: "notification__update-item__content" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_NotificationTemplate = _resolveComponent("NotificationTemplate")!

  return (_openBlock(), _createBlock(_component_NotificationTemplate, {
    notification: _ctx.notification,
    projectName: _ctx.notification.projectName,
    showSubTitle: false,
    class: "notification__milestone-back-to-track"
  }, {
    pic: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_icon, {
          data: _imports_0,
          class: "label-pic__icon",
          width: "var(--icon-24)",
          height: "var(--icon-24)"
        })
      ])
    ]),
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BaseSubHeading, {
          size: "large",
          color: "monochrome-06",
          darkColor: "monochrome-03",
          weight: "500"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Milestone Back on Track! ")
          ]),
          _: 1
        }),
        _createVNode(_component_BaseSubHeading, {
          size: "small",
          color: "monochrome-05",
          darkColor: "monochrome-04",
          weight: "500"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.notification.projectName), 1)
          ]),
          _: 1
        })
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          href: _ctx.notification.url,
          class: "link is-medium-500",
          target: "_blank"
        }, _toDisplayString(_ctx.notification.milestoneName), 9, _hoisted_4),
        _createVNode(_component_BaseSubHeading, {
          size: "medium",
          color: "monochrome-07",
          weight: "500",
          className: "body-text-medium-500 milestone-date"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.notification.milestoneDate), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_BaseSubHeading, {
        size: "medium",
        color: "monochrome-07",
        weight: "500",
        className: "body-text-medium-500 notification__update-item__content"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.notification.daysLeft) + " Days Left, " + _toDisplayString(_ctx.notification.percentComplete) + "% Done ", 1)
        ]),
        _: 1
      }),
      (_ctx.notification.currentGoalContent)
        ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
            key: 0,
            size: "medium",
            color: "monochrome-06",
            darkColor: "monochrome-03",
            weight: "400"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.notification.currentGoalContent), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["notification", "projectName"]))
}